import React from 'react';

import { LinkButton } from '@backstage/core-components';

import { Box, Typography } from '@material-ui/core';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { Alert } from '@material-ui/lab';

export const MatchMakingAlert = () => (
  <Box marginBottom="10px">
    <Alert severity="info" role="alert" data-testid="matchmaking-alert">
      Matchmaking sessions help Explorers connect with others and build stronger
      teams. If you already have an idea and need support assembling your crew,
      register for a Matchmaking session. You'll have the opportunity to present
      your idea, meet potential teammates, and find the skills and expertise
      needed to move your Mission forward.
      <br />
      <Box
        flexDirection="row"
        display="flex"
        alignItems="center"
        marginTop="8px"
      >
        <Typography variant="body2" component="strong">
          <LinkButton
            to="https://forms.cloud.microsoft/e/aLfRMEWJS2"
            color="secondary"
            variant="contained"
            size="small"
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: '0.75rem', textTransform: 'none' }}
          >
            <OpenInNewIcon
              style={{ marginRight: '5px', fontSize: '0.95rem' }}
            />
            Register
          </LinkButton>
        </Typography>
      </Box>
    </Alert>
  </Box>
);
